import { PrimaryButton, TextField } from "@fluentui/react";
import * as React from "react";
import axios from "axios";
import { isStringValidated } from "../Global/Constant";
import { SweetAlerts } from "../Global/SweetAlert";
import ContextService from "../../services/ContextService";
import { Label, Toggle, TooltipHost } from "office-ui-fabric-react";
import { Info16Regular } from "@fluentui/react-icons";
import '../Home.css';
function Settings(props) {
console.log(props)
  const [siteURL,setSiteURL]=React.useState("")

  const [azureOpenAIData, setAzureOpenAIData] = React.useState<any>({
    Endpoint: "",
    APIkey: "",
    DeploymentName: "",
    AzureOpenAIToggle: false,
  });
  const [Copilot, setCopilot] = React.useState({ Url:'', CopilotToggle:'No'})
  const [loading1, setLoading1] = React.useState(false);
  const [ButtonSaveText1, setButtonSaveText1] = React.useState<string>(
    "Save"
  );
  const { SweetAlert: SweetalertSettings,SweetPrompt:SweetalertPrompt } = SweetAlerts("#SweetalertSettings");

  React.useEffect(()=>{
    const AzureAI:any= JSON.parse(localStorage.getItem("AzureAI")||"{}")
    const Copilot:any= JSON.parse(localStorage.getItem("Copilot")||"{}")
    const AzureAIData={
      ...AzureAI,
      // AzureOpenAIToggle:true
    }
    const CopilotData = {
      ...Copilot
    }
    // console.log(AzureAIData,"AzureAIData")
    setAzureOpenAIData(AzureAIData)
    setCopilot(CopilotData)
  },[])
   const handleToggleChange = (key) => (_, checked) => {
    if (checked) {
      setAzureOpenAIData((pre)=>({...pre, AzureOpenAIToggle: key === 'openAI'}))
      setCopilot((pre)=>({...pre, CopilotToggle: key === 'Copilot' ?'Yes' : 'No'}))
    } else {
      if (key === 'openAI') {
      setAzureOpenAIData((pre) => ({ ...pre, AzureOpenAIToggle: false }));
    } else {
      setCopilot((pre) => ({ ...pre, CopilotToggle: 'No' }));
    }
    }
  };
  // const saveSiteCredential=()=>{
  //   const urlInput = siteURL?.trim();
  //   if (isStringValidated(urlInput)) {
  //     SweetalertPrompt("warning",'Are you sure you want to update the site url?').then((c)=>{
  //       if(c.isConfirmed){
     
  //         const tenantUrlPattern = /^https:\/\/[a-zA-Z0-9-]+\.((sharepoint\.com)|(onmicrosoft\.com))(\/.*)?$/;
  //         if (!tenantUrlPattern.test(urlInput)) {
  //           SweetalertSettings('error',`'Invalid tenant URL. Please use a valid URL like https://tenantname.sharepoint.com';`)
  //           // messageLabel.textContent = 'Invalid tenant URL. Please use a valid URL like https://tenantname.sharepoint.com';
  //           return;
  //         }else{
  //           const tenantURL= urlInput?.split("/sites")[0]
  //           localStorage.setItem("SiteURL", urlInput);
  //           localStorage.setItem("TenantURL", tenantURL);
  //           SweetalertSettings('success','Site URL submitted successfully')
            
  //         }
    
  //       }
  //     })
  //   }else {
  //     SweetalertSettings('error',"Please enter a site URL")
  //   }


  // }


  const saveAzureAICredential = () => {
    // console.log("posting")
    setLoading1(true);
    setButtonSaveText1("");
    const finalTemplate = {
          AzureAI: JSON.stringify(azureOpenAIData),
          CopilotIntegration: JSON.stringify(Copilot)
        }
     if (azureOpenAIData?.AzureOpenAIToggle) {
      if (
        azureOpenAIData?.Endpoint?.trim() === "" ||
        azureOpenAIData?.APIkey.trim() === "" ||
        azureOpenAIData?.DeploymentName.trim() === "" ||
        !azureOpenAIData?.Endpoint ||
        !azureOpenAIData?.APIkey ||
        !azureOpenAIData?.DeploymentName ||
        azureOpenAIData == null ||
        azureOpenAIData == undefined
      ) {
        if (azureOpenAIData?.Endpoint == "" || !azureOpenAIData?.Endpoint) {
          SweetalertSettings("error", "Please enter Azure AI endpoint"); //Azure AI
        } else if (azureOpenAIData?.APIkey == "" || !azureOpenAIData?.APIkey) {
          SweetalertSettings("error", "Please enter Azure AI api key");
        } else if (azureOpenAIData?.DeploymentName == "" || !azureOpenAIData?.DeploymentName) {
          SweetalertSettings("error", "Please enter Azure AI deployment name");
        }
        setLoading1(false);
        setButtonSaveText1("Save");
      } else {
        updateSettings(finalTemplate)
      }
    }else if(Copilot?.CopilotToggle === 'Yes') {
      if(Copilot?.Url !== undefined && Copilot?.Url?.trim() === ''){
          updateSettings(finalTemplate)
      } else {
        SweetalertSettings("error", "Please enter PA Url");
      }
    } else {
        updateSettings(finalTemplate)
      }
  }

  const updateSettings = (finalTemplate) => {
const settingsListID= localStorage.getItem("settingsListID");
const token=localStorage.getItem("CurrentToken");
      const _url =
      ContextService.GetUrl() +
      "/_api/web/lists/getbytitle('CLM365Settings')/items('" +
      settingsListID +
      "')";
       axios.post(_url, finalTemplate,{
        headers: {
          Accept: "application/json;odata=nometadata",
          "Content-type": "application/json;odata=nometadata",
          "odata-version": "",
          "IF-MATCH": "*",
          "X-HTTP-Method": "MERGE",
          Authorization: `Bearer ${token}`, 
        },
        // body: JSON.stringify(finalTemplate),
      })
      .then((response) => {
        localStorage.setItem("AzureAI",JSON.stringify(azureOpenAIData))
        localStorage.setItem("Copilot",JSON.stringify(Copilot))
        if (response.status === 204) {
          console.log("Successfully updated.");
        } else {
          console.warn("Unexpected response status:", response.status);
        }
        SweetalertSettings('success','Submitted Successfully')
        setLoading1(false);
        setButtonSaveText1("Save");
      })
      .catch((error) => {
        setLoading1(false);
        setButtonSaveText1("Save");
        console.error("Error updating the item:", error);
      });
  }
  return (
    <>
    <div>
      {/* <div>
        <div className={"LableAndInfo"}>
          <Label>{"Client ID"}</Label>
          <Tooltip withArrow content={"Please enter Client Id (ex: '1xxxxx28-axx5-4c0a-bxxa-97exxxx5c4xx')"} relationship="label">
            <Info20Regular style={{ marginLeft: "5px" }} />
          </Tooltip>
          
        </div>
        <Input placeholder="1xxxxx28-axx5-4c0a-bxxa-97exxxx5c4xx"/>
      </div> */}

      {/* <div>
        <div className={"LableAndInfo"} style={{paddingBottom:'5px'}}>
          <Label required style={{fontWeight:'600'}}>{"Site URL"}</Label>
          <Tooltip withArrow content={"Please enter Site URL (ex:'https://yourtenant.sharepoint.com/sites/yoursitename)"} relationship="label">
            <Info20Regular style={{ marginLeft: "5px" }} />
          </Tooltip>
          
        </div>
        <TextField placeholder="https://yourtenant.sharepoint.com/sites/yoursitename" value={siteURL} onChange={(ev:any,Newval)=>{
            console.log(ev)
          setSiteURL(Newval)
        }} />
      </div> */}

<div>
          <div className="Integration">
          <div className="SettingsIntegration">
           <div className="IntegrationInfo">
            <Label>Azure Open AI</Label>
           <TooltipHost content={'Please follow the Kb Article for activation of Azure AI.'}>
                  <Info16Regular  style={{marginTop:'5px'}}/>
                </TooltipHost></div>
                 <Toggle
                  checked={azureOpenAIData?.AzureOpenAIToggle}
                  onChange={handleToggleChange('openAI')}
                  onText="On"
                  offText="Off">
                </Toggle></div>
                {azureOpenAIData?.AzureOpenAIToggle && <div>
              <div  >
                <TextField
                label="Azure AI Endpoint"
                required
                  name="Endpoint"
                  placeholder={"Enter Endpoint"}
                  onChange={(_event, newVal) => {
                    setAzureOpenAIData((c) => ({
                      ...c,
                      Endpoint: newVal
                    }));
                  }}
                  value={azureOpenAIData?.Endpoint}
                />
              </div>

              <div >
               
                <TextField
                  name="APIkey"
                  required
                  label={"Azure AI API Key"}
                  placeholder={"Enter azure key"}
                  onChange={(_event, newVal) => {
                    setAzureOpenAIData((c) => ({
                      ...c,
                      APIkey: newVal
                    }));
                  }}
                  value={azureOpenAIData?.APIkey}
                />
              </div>

              <div >
                <TextField
                label={"Azure AI Deployment Name"}
                required
                  name="DeploymentName"
                  placeholder={"Enter deployment name"}
                  onChange={(_event, newVal) => {
                    setAzureOpenAIData((c) => ({
                      ...c,
                      DeploymentName: newVal
                    }));
                  }}
                  value={azureOpenAIData?.DeploymentName}
                />
              </div>
        </div>}
        </div>
        <div style={{ marginTop:'10px'}} className="Integration" >
          <div className="SettingsIntegration">
            <div className="IntegrationInfo">
           <Label>Copilot Integration</Label>
           <TooltipHost content={'Enable or disable Copilot integration. Enter the configured Power Automate (PA) URL and click Save to activate the copilot feature.'}>
              <Info16Regular style={{marginTop:'6px'}}/>
                </TooltipHost></div>
                 <Toggle
                  checked={Copilot?.CopilotToggle=='Yes'}
                  onChange={handleToggleChange('Copilot')}
                  onText="On"
                  offText="Off">
                </Toggle></div>
                {Copilot?.CopilotToggle=='Yes' && <TextField
                label={"Configured PA Url"}
                required
                placeholder={"Enter configured PA Url"}
                onChange={(_event, newVal) => {
                  setCopilot((c) => ({
                    ...c,
                    Url: newVal
                  }));
                }}
                value={Copilot?.Url}/>
                }
            </div>
      <div style={{ marginTop: "1rem" }}>
              <PrimaryButton
                text={"Save"}
                className={"savebutton"}
                onClick={saveAzureAICredential}
              ></PrimaryButton>
            </div>
      </div></div>
    </>
  );
}

export default Settings;
